import React, { useContext, useMemo } from 'react';
import { format as formatDate, isAfter, isEqual, addMonths, startOfMonth } from 'date-fns';

import { CalendarContext } from '../../context/CalendarContext.jsx';

function FilterPreviewSwitch() {
  const { config, locale, currentMonth, activeMonth } = useContext(CalendarContext);

  const months = useMemo(
    () =>
      [...Array(2).keys()].map((i) => {
        const month = addMonths(currentMonth, i);

        return {
          month,
          label: formatDate(month, 'MMM', { locale }),
          id: formatDate(startOfMonth(month), 'MM/dd/yy')
        };
      }),
    [config]
  );

  const previewMonth = useMemo(() => {
    const month = startOfMonth(addMonths(months[months.length - 1].month, 1));
    return formatDate(startOfMonth(month), 'MM/dd/yy');
  }, [config]);

  const isActivePreviewMonth = () => {
    const activeDate = new Date(activeMonth);
    const previewDate = new Date(previewMonth);
    const isAfterMonth = isAfter(activeDate, previewDate);
    const isEqualMonth = isEqual(activeDate, previewDate);
    return isAfterMonth || isEqualMonth;
  };

  return (
    <div className="filter-preview-switch">
      {months.map((i) => (
        <a href={`#${i.id}`} className={`text text--small-link ${activeMonth === i.id ? 'is-selected' : ''}`}>
          <span>{i.label}</span>
        </a>
      ))}

      <a href={`#${previewMonth}`} className={`text text--small-link ${isActivePreviewMonth() ? 'is-selected' : ''}`}>
        <span>{config.labels.preview}</span>
      </a>
    </div>
  );
}

export default FilterPreviewSwitch;
